import 'css-chunksrc/client/common/secondaryCriteriaForm/numberForm/numberInput/styles.scss';export default {
  "numberInput": "_numberInput_vouzm_1"
};